import { gql } from '@apollo/client';

const GET_COMPANY_TASK_LIST_PARTNERS = gql`
  query GetCompanyTaskListPartners {
    viewer {
      id
      company {
        id
        taskListPartners {
          nodes {
            id
            name
            __typename
          }
        }
      }
    }
  }
`;

export default GET_COMPANY_TASK_LIST_PARTNERS;
